import * as Config from '@/Config';
import VuexPersist from 'vuex-persist';
import authentication from './Module/Authentication/Persist';
import global from './Module/Global/Persist';
import location from './Module/Location/Persist';
import pad from './Module/Pad/Persist';
import settings from './Module/Settings/Persist';
import userGuidance from './Module/UserGuidance/Persist';
import versionHistory from './Module/VersionHistory/Persist';

/**
  ┌────────────────────────────────────────────────────────────────────────────┐
  │                                                                            │
  │ Store/Persist                                                              │
  │                                                                            │
  │ Custom storage adapter that mixes with Vuex and Vuex-Persist. Ordinarily   │
  │ those would combine with LocalStorage, but this plugin will prioritize     │
  │ chrome.storage.local if it's available.                                    │
  │                                                                            │
  │ Example:                                                                   │
  │                                                                            │
  │     import Persist from '~/store/persist';                                 │
  │                                                                            │
  │     new Vuex.Store({                                                       │
  │         ...                                                                │
  │         plugins: [                                                         │
  │             new VuexPersist(Persist.options),                              │
  │         ]                                                                  │
  │     });                                                                    │
  │                                                                            │
  │ @see https://github.com/championswimmer/vuex-persist                       │
  │                                                                            │
  └────────────────────────────────────────────────────────────────────────────┘
*/

const persist = new VuexPersist({
	asyncStorage: false,
	key: Config.App.STORAGE_KEY,
	reducer: (state: IKeyValue) => ({
		authentication: authentication(state.authentication),
		global: global(state.global),
		location: location(state.location),
		pad: pad(state.pad),
		settings: settings(state.settings),
		userGuidance: userGuidance(state.userGuidance),
		versionHistory: versionHistory(state.versionHistory),
	}),
	storage: window.localStorage,
});

export default persist.plugin;
